import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { brandRelatedPublicationsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { dealwithCommonDate, useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import BubbleCommon, {
  brandRelatedPublicationsFilterTips,
} from '@op/components/BubbleCommon';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function BrandRelatedPublicationsSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'brand_publications',
      subDefaultKey: 'brand_publication',
      oriDefaultFilter,
      backOriDefaultValue,
      dealwithDateFunc: dealwithCommonDate,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 5', value: '0-5' },
        { text: '5 ~ 10', value: '5-10' },
        { text: '10 ~ 15', value: '10-15' },
        { text: '15+', value: '15-' },
      ],
    });
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      let dataItem: {
        start_brand_publication: number;
        end_brand_publication?: number;
      } = {
        start_brand_publication: Number(start),
      };
      if (end !== '') {
        dataItem['end_brand_publication'] = Number(end);
      }
      data.push(dataItem);
    }

    onChange?.(
      'brandRelatedPublications',
      commonBackInfo(
        { brand_publications: data },
        { brandRelatedPublications: showHeader },
      ),
    );
  }, [rangeValue, formatMessage]);

  return (
    <BubbleCommon
      placement="top"
      showIcon={false}
      tipsMap={brandRelatedPublicationsFilterTips}
    >
      <div className={`dbo-brand-relate-publications-wrapper ${diffClassName}`}>
        <CustomFollowerRange
          lang={lang}
          ref={followerRef}
          options={options}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          unit=""
          pointKey={FilterButtonPoint.brandRelatedPublications}
          placeholder={brandRelatedPublicationsPlaceholder}
        ></CustomFollowerRange>
      </div>
    </BubbleCommon>
  );
}
